/**
* How to cite Template
* Created by Emmanuella Albuquerque on 2023/03/16.
*/

export function Howtocite() {
  return (
    <p>
    {"de Morais Melo, L. F., de Oliveira Filho, L. P., de Assis Ferreira, U., Alves, E. H. P., Costa, R. P. O., Scotti, L., & Scotti, M. T. (2025). AmIActive (AIA): A Large-scale QSAR Based Target Fishing and Polypharmacology Predictive Web Tool. Journal of Molecular Biology, 169090."}
    <br/>
    <br/>

      <a href="https://doi.org/10.1016/j.jmb.2025.169090"
        title="DOI Reference" target="_blank" rel="noopener noreferrer"
      >
        {"https://doi.org/10.1016/j.jmb.2025.169090"}</a>
    </p>

  );
}
